import * as Api from '../../../../api/Api';
import { useState } from 'react';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import TableFromServer from "../../../../Components/Table/TableFromServer";
import * as Utilities from '../../../../Components/Utils/Utils';
import AgTable from '../../../../Components/Table/AgTable';

function IndicadorVenta({ tipoReporte }) {

    const [auxData, setAuxData] = useState({ porcentajeReal: null, porcentajeProvisionado: null, total: null });
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
        "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
    ];
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const yearold = currentDate.getFullYear() - 4;
    const month = monthNames[currentDate.getMonth()];
    const closedMonth = monthNames[currentDate.getMonth() - 1];
    const day = currentDate.getDate();
    const [ventasAnio1, setVentasAnio1] = useState(null)
    const [ventasAnio2, setVentasAnio2] = useState(null)
    const headerTableVentaMensual = [
        {
            headerName: 'Mall',
            field: 'mall',
            rowDrag: true,
            aggFunc: () => ('Total')
        },
        {
            headerName: `Venta ${month} ${year}`,
            field: 'ventaMesAnioActual',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio1),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: `Venta ${month} 2019`,
            field: 'ventaMesAnioPasado',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio2),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (ventasAnio1 - ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (((ventasAnio1 - ventasAnio2) * 100) / ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.value)}</>
            )
        },
    ]

    const headerVentaMensualM2 = [
        {
            headerName: 'Mall',
            field: 'mall',
            className: 'min-w-125px column-left',
            aggFunc: () => ('Total')
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {year}</span>),
            field: 'ventaM2MesAnioActual',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio1),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {yearold}</span>),
            field: 'ventaM2MesAnioPasado',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio2),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (ventasAnio1 - ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (((ventasAnio1 - ventasAnio2) * 100) / ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.value)}</>
            )
        }
    ];
    const headerVentaMensualCerrado = [
        {
            headerName: 'Mall',
            field: 'mall',
            className: 'min-w-100px column-left',
            aggFunc: () => ('Total')
        },
        {
            headerName: `Venta ${closedMonth} cerrado ${year}`,
            field: 'ventaMesCerradoAnioActual',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio1),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: `Venta ${closedMonth} cerrado ${yearold}`,
            field: 'ventaMesCerradoAnioPasado',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio2),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (ventasAnio1 - ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? (((ventasAnio1 - ventasAnio2) * 100) / ventasAnio2).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.value)}</>
            )
        }
    ];
    const token = useGetToken();

    return (
        <>
            <div className='flex-grow-1 pb-0'>
                {(tipoReporte.value === "ventaMensual" ||
                    tipoReporte.value === "ventaMensualM2") &&
                    <>
                        <div className="me-2">
                            <div className="text-muted fs-7 fw-bold">Venta del {auxData.fecha}</div>
                        </div>

                    </>
                }
                {tipoReporte.value === "ventaMensualCerrado" &&
                    <>
                        <div className="me-2">
                            <div className="text-muted fs-7 fw-bold">A nivel nacional</div>
                        </div>

                    </>
                }
                <div className="fw-bolder fs-3 text-primary">S/ {Utilities.comillasFix(auxData.montoVenta)}</div>
                {(tipoReporte.value === "ventaMensual" ||
                    tipoReporte.value === "ventaMensualM2") &&
                    <>
                        <div className="me-2">
                            <div className="text-dark  fw-bolder fs-3">Comparativo Periodo por Mall </div>
                        </div>
                    </>
                }
                {tipoReporte.value === "ventaMensualCerrado" &&
                    <>
                        <div className="me-2">
                            <div className="text-dark  fw-bolder fs-3">Venta Cerrada {auxData.mesCierre} </div>
                        </div>
                    </>
                }
            </div>

            {
                tipoReporte.value === "ventaMensual" &&
                (
                    <>
                        <AgTable
                            idContent={"IndicadoresVentasMensual " + tipoReporte.value}
                            apiService={Api.IndicadoresVentasMes}
                            setAuxData={setAuxData}
                            header={headerTableVentaMensual}
                            titleExcel={"Indicadores Ventas Mensual " + tipoReporte.value}
                            conditions={true}
                            args={{ token: token }}
                            hideFilter={true}
                            paginationPageSize={8}
                            sumColumns={true}
                            useFlex={false}
                        />
                    </>
                )
            }
            {
                tipoReporte.value === "ventaMensualM2" &&
                (
                    <>
                        <AgTable
                            idContent={"IndicadoresVentasMensualM2 " + tipoReporte.value}
                            apiService={Api.IndicadoresVentasMesM2}
                            setAuxData={setAuxData}
                            header={headerVentaMensualM2}
                            titleExcel={"Indicadores Ventas MensualM2 " + tipoReporte.value}
                            conditions={true}
                            args={{ token: token }}
                            hideFilter={true}
                            paginationPageSize={8}
                            sumColumns={true}
                            useFlex={false}
                        />
                    </>
                )
            }
            {
                tipoReporte.value === "ventaMensualCerrado" &&
                (
                    <>
                        <AgTable
                            idContent={"IndicadoresVentasMensualCerrado " + tipoReporte.value}
                            apiService={Api.IndicadoresVentasMesCerrado}
                            setAuxData={setAuxData}
                            header={headerVentaMensualCerrado}
                            titleExcel={"Indicadores Ventas Mensual Cerrado" + tipoReporte.value}
                            conditions={true}
                            args={{ token: token }}
                            hideFilter={true}
                            paginationPageSize={8}
                            sumColumns={true}
                            useFlex={false}
                        />
                    </>
                )
            }

        </>
    )
}

export default IndicadorVenta;
